import { event, payload } from '@conversa/reflex';

export const FetchCheckupResponsesRequested = event(
  '[ component | Completed Chats Table ] Fetch Checkup Responses Requested',
  payload<{ checkupId: number }>(),
);
